const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "\\u0428\\u0430\\u0440 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "\\u043F\\u043B\\u043E\\u0449\\u0430"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m63.25,1.75v61.49H1.75V1.75h61.49m1.75-1.75H0v65h65V0h0Z",
    style: {
      fill: "#0f0f0f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 59.43,
    y1: 5.97,
    x2: 47.78,
    y2: 17.63,
    style: {
      fill: "none",
      stroke: "#0f0f0f",
      strokeMiterlimit: 10,
      strokeWidth: "1.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.25 5.01 50.31 6.76 58.95 6.45 58.64 15.09 60.39 15.15 60.77 4.62 50.25 5.01",
    style: {
      fill: "#0f0f0f",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 5.77,
    y1: 5.97,
    x2: 17.42,
    y2: 17.63,
    style: {
      fill: "none",
      stroke: "#0f0f0f",
      strokeMiterlimit: 10,
      strokeWidth: "1.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.8 15.15 6.56 15.09 6.24 6.45 14.88 6.76 14.95 5.01 4.42 4.63 4.8 15.15",
    style: {
      fill: "#0f0f0f",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 59.43,
    y1: 59.28,
    x2: 47.78,
    y2: 47.63,
    style: {
      fill: "none",
      stroke: "#0f0f0f",
      strokeMiterlimit: 10,
      strokeWidth: "1.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.39 50.1 58.64 50.16 58.96 58.8 50.31 58.49 50.25 60.24 60.78 60.62 60.39 50.1",
    style: {
      fill: "#0f0f0f",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 5.77,
    y1: 59.28,
    x2: 17.42,
    y2: 47.63,
    style: {
      fill: "none",
      stroke: "#0f0f0f",
      strokeMiterlimit: 10,
      strokeWidth: "1.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.95 60.24 14.89 58.49 6.24 58.81 6.56 50.16 4.8 50.1 4.42 60.63 14.95 60.24",
    style: {
      fill: "#0f0f0f",
      strokeWidth: 0
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.12269c6112f1607e76749e5728e6953a.svg";
export { ForwardRef as ReactComponent };